import React from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as d3 from "d3";
import { LineChart } from "./helpers/MutliLineHelper";
import moment from 'moment';
import * as orderStatsService from "../services/orderStats.service";
import * as opOrderStatsService from "../services/openprintStats.service";
import * as spOrderStatsService from "../services/subprintStats.service";
import * as ipOrderStatsService from "../services/iprintStats.service";

class MultiLineChart extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      ordersData: [],
      revvenueData: [],
      currTimeFrame: null,
      spin: false,
    }
  }
  componentDidMount() {
    let timeFrame;
    let service;
    if (this.props.time == 'day') {
      timeFrame = 'Day';
    } else if (this.props.time == 'month') {
      timeFrame = 'Month';
    }
    this.setState({
      spin: true,
    });
    if (this.props.system === 'PV') {
      service = orderStatsService;
    } else if (this.props.system === 'OP') {
      service = opOrderStatsService;
    } else if (this.props.system === 'SP') {
      service = spOrderStatsService;
    } else if (this.props.system === 'IP') {
      service = ipOrderStatsService;
    }
    if (service && ((this.props.type == "orders") || (this.props.type == "revenue"))) {
      service.getPrelimLines(this.props.time).then(response => {
        let orders;
        let revenue;
        if (this.props.type == 'orders') {
          let orders = response.orderData
          this.drawChart(orders, this.props.width, this.props.height, this.props.type);
        } else if (this.props.type == 'revenue') {
          let revenue = response.revenueData;
  
          this.drawChart(revenue, this.props.width, this.props.height, this.props.type);
        }
        
        this.setState({
          spin: false,
          ordersData: orders,
          revenueData: revenue,
          currTimeFrame: timeFrame
        });
      }).catch(err => {
        console.log(err)
      });
    } else if (service && this.props.type == "items") {
      if (this.props.context == "created") {
        service.getPrelimItemLines(this.props.time).then(response => {
          let orders = response.itemData
          this.drawChart(orders, this.props.width, this.props.height, this.props.type);
          this.setState({
            spin: false,
            ordersData: orders,
            currTimeFrame: timeFrame
          });
        }).catch(err => {
          console.log(err)
        });
      } else if (this.props.context == "shipping") {
        service.getShippingLines(this.props.time).then(response => {
          let orders = response.itemData
          this.drawChart(orders, this.props.width, this.props.height, this.props.type);
          this.setState({
            spin: false,
            ordersData: orders,
            currTimeFrame: timeFrame
          });
        }).catch(err => {
          console.log(err)
        });
      }
      
    }
    
    // console.log(this.props.data)
    // if (this.props.data.length > 0) {
    //   console.log("Do Something")
    //   this.drawChart(this.props.data, this.props.width, this.props.height, this.props.type);
    // } else {
    //   console.log("Do Nothing")
    // }
    
    // let chart;
    // console.log(this.props.data);
    // console.log(this.props.width);
    // console.log(this.props.height);
    // console.log(this.props.type);
    // chart = LineChart(this.props.data, {
    //   x: d => d.date,
    //   y: d => d[this.props.type],
    //   z: d => d.division,
    //   yLabel: `↑ ${this.props.type}`,
    //   width: this.props.width,
    //   height: this.props.height,
    //   color: "steelblue",
    //   //voronoi // if true, show Voronoi overlay
    // })
  }


  drawChart = (data, width, height, type) => {
    let chart;
    chart = LineChart(data, {
      x: d => moment(d.date).toDate(),
      y: d => d[type],
      z: d => d.division,
      yLabel: `↑ ${type}`,
      width: width,
      height: height,
      color: "steelblue",
      //title: d.title,
      //voronoi: true // if true, show Voronoi overlay
    })
    this.setState({
      spin: false,
    });
    d3.select('#chart_' + this.props.type + this.props.time + this.props.system + this.props.context).exit().remove()
    d3.select('#chart_' + this.props.type + this.props.time + this.props.system + this.props.context).node().append(chart)
    return chart;
  }

  render() {
    return (
      <div className='mt-2'>
        {this.state.spin ? 
        <svg role="status" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg> : null}
        {!this.state.spin ? <h5 className='ml-4'> {this.props.system == 'PV' ? "PVP" : this.props.system} {this.props.title} By {this.state.currTimeFrame} </h5> : null }
        <div id={'chart_' + this.props.type + this.props.time + this.props.system + this.props.context} className="ml-4" />
      </div>
    )
  }
}

export default MultiLineChart;